/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_Stat_1_LabelInputs */

const en_landing_guide_stat_1_label = /** @type {(inputs: Landing_Guide_Stat_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native output`)
};

const zh_landing_guide_stat_1_label = /** @type {(inputs: Landing_Guide_Stat_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原生输出`)
};

/**
* | output |
* | --- |
* | "Native output" |
*
* @param {Landing_Guide_Stat_1_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_stat_1_label = /** @type {((inputs?: Landing_Guide_Stat_1_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_Stat_1_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_stat_1_label(inputs)
	return zh_landing_guide_stat_1_label(inputs)
});
export { landing_guide_stat_1_label as "landing.guide.stat_1_label" }